import { OrderStatus, StopType } from 'harmony-constants';
import { Load } from '../../../types';
import { CreateStop, typedCreateStop } from './typed-create-stop';
import moment from 'moment-timezone';

// type Load/Stop not perfect here
// mapping undef on stop.orderId is handled api side
export const typedCreateLoad = (organizationId: number, isDraft: boolean, stops?: CreateStop[]): Load => {

    const getStops = () => {
        if (isDraft) {
            return [
                typedCreateStop(undefined, { type: StopType.Destination, sequence: 1 }),
            ];
        } else {
            return [
                typedCreateStop(undefined, { type: StopType.Origin, sequence: 1 }),
                typedCreateStop(undefined, { type: StopType.Destination, sequence: 2 }),
            ];
        }
    }

    return {
        date: moment().toISOString(),
        organizationId: organizationId,
        transportingOrganizationId: organizationId,
        transportedByUserId: null,
        isDraft: isDraft,
        status: OrderStatus.Open,
        tractorId: null,
        trailerId: null,
        // @ts-ignore
        stops: stops || getStops(),
        mergedFromOrderIds: null,
        timeSeconds: null,
        distanceMeters: null,
    };
}
